import {
  getFUn
} from '../auth_lib'

export default {
  ...getFUn('agreement')
}